import { Menu, MenuItem } from "@mui/material";
import { apiGetGardesh } from "api/reportApi";
import FiterIconAccount from "assets/icons/FilterIcon";
import GreenRefresh from "assets/icons/GreenRefresh";
import GroupAccount from "assets/icons/GroupAccount";
import HeadOfGroup from "assets/icons/HeadOfGroup";
import History from "assets/icons/History";
import Kol from "assets/icons/Kol";
import Moien from "assets/icons/Moien";
import Tafsil from "assets/icons/Tafsil";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { options } from "components/Shared/Dashboard/LineChartComponent";
import { indexData } from "forms";
import { setSelectItemLabels } from "helpers";
import { getQueryParam, setQueryParam, setQueryParams } from "helpers/queryParam";
import useDateState from "helpers/useDateState";
import Financial from "pages/financial/Financial";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setTableData } from "store/actions/dataTableAction";
import { store, useAppSelector } from "store/store";
import { number } from "zod";
export const FooterActionsReviewAccount = ({ selectedItem, selectedItems }: { selectedItem: any, selectedItems: any }) => {
    const { dispatch, getState } = store
    const tabs = indexData("reviewAccount") as any
    const activeTab = tabs[0]
    const rightLevel = getQueryParam("rightLevel");
    const topLevel = getQueryParam("topLevel")
    const paginationState = getState().paginationReducer
    const token = getState().businessReducer.business?.token;
    const navigate = useNavigate()
    return (
        <div className="flex gap-4 w-full flex-row-reverse">
            <BasicButton about="isGardesh" variant="contained" className="bg-[#EBFBF3] rounded-lg text-black border border-[1px solid #2ec277]" onClick={() => {
                navigate(`/reports/gardesh?rightLevel=${rightLevel}&topLevel=${topLevel}`,)

            }}><GreenRefresh />گردش حساب</BasicButton>
        </div>
    )
}
const FilterAccountReview = ({ type }: { type: string }) => {
    const tabs = indexData(type) as any

    const activeTab = tabs[0]
    const { dispatch, getState } = store
    const paginationState = getState().paginationReducer
    const selectBoxTableValueReducer = useAppSelector(state => state.selectBoxTableValueReducer) as any
    const selectedRows = selectBoxTableValueReducer.selectedIds["reviewAccount"] || []
    const token = getState().businessReducer.business?.token;
    const fromParamsRightLevel = getQueryParam("rightLevel");
    const fromParamstopLevel = getQueryParam("topLevel")
    const rightValue = !isNaN(Number(fromParamsRightLevel)) && Number(fromParamsRightLevel) > 0 ? Number(fromParamsRightLevel) : null
    const topValue = !isNaN(Number(fromParamstopLevel)) && Number(fromParamstopLevel) > 0 ? Number(fromParamstopLevel) : null
    const [rightLevel, setRightLevel] = useState<null | number>(rightValue)
    const [topLevel, setTopLevel] = useState<null | number>(topValue)
    const [historyList, setHistoryList] = useState<Array<{ level: number, title: string, id: number }>>([])
    const [anchorEl, setAnchorEl] = useState<any>([]);
    const onClickLevel = (level: number) => {
        if (rightLevel === level && topLevel === null) {
            setRightLevel(null)
            setQueryParam("rightLevel", "")
        } else if (topLevel === level) {
            setTopLevel(null)
            setQueryParams([{ key: "topLevel", value: "" }, { key: "rightLevel", value: rightLevel ? rightLevel : "" }])
        } else if (topLevel === null && rightLevel === null) {
            setRightLevel(level)
            setQueryParam("rightLevel", level)
        } else if (rightLevel != null && level !== rightLevel) {
            setTopLevel(level)
            setQueryParams([{ key: "topLevel", value: level }, { key: "rightLevel", value: rightLevel }])
        } else {
            setRightLevel(level)
            setQueryParam("rightLevel", level)
            setTopLevel(null)
        }
        if (selectedRows.length > 0) {
            const rows = getState().dataTableReducer.items
            selectedRows.map((x: any) => {
                const row = rows.find((y: any) => x === y.id)
                if (row) {
                    setHistoryList((state) => {
                        const newState = [...state]
                        newState.push({ level: newState.length + 1, id: x, title: row.title })
                        return newState
                    })
                }
            })
        }
    }

    useEffect(() => {
        if (rightLevel === null || (rightLevel === null && topLevel === null)) {
            dispatch(setTableData([]));

        } else {
            //@ts-ignore
            const fromDate = getState().appReducer?.fromDate
            //@ts-ignore
            const toDate = getState().appReducer?.toDate
            let { search, sort } = paginationState;
            let options: any = {
                rightLevel,
                topLevel,
                "subColumn": "date",
                "searchText": fromDate,
                "searchTextAlt": toDate,
            };
            dispatch(
                activeTab.actions?.fetch({
                    pagination: paginationState,
                    search,
                    sort,
                    token,
                    options,
                })
            );
        }
        return () => {

        }
    }, [rightLevel, topLevel])


    return (
        <div className="flex gap-4  mt-4 flex-nowrap w-full place-content-center place-items-center">
            {/* <BasicButton className="w-[35px] p-[2px] h-[35px] min-w-[35px] min-h-[35px]" onClick={(ev) => {
                setAnchorEl(ev.target)
            }} variant="contained"  ><History /></BasicButton> */}
            <BasicButton about="reviewAccount" className={` [&>.MuiButton-endIcon]:w-2/5 [&>.MuiButton-endIcon]:justify-end text-black w-1/5 ${rightLevel === 1 ? 'text-white' : topLevel === 1 ? "bg-[#E7EFFA]" : 'bg-[#FAFCFF]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => onClickLevel(1)} variant="contained" endIcon={selectedRows.length > 0 && rightLevel === 1 ? <span className="px-[6px] py-[5px] bg-[#B5CEF0] rounded "><FiterIconAccount /></span> : undefined}  ><HeadOfGroup stroke={`${rightLevel === 1 ? '' : 'black'}`} />سرگروه </BasicButton>
            <BasicButton about="reviewAccount" className={` [&>.MuiButton-endIcon]:w-2/5 [&>.MuiButton-endIcon]:justify-end text-black w-1/5 ${rightLevel === 2 ? 'text-white' : topLevel === 2 ? "bg-[#E7EFFA]" : 'bg-[#FAFCFF]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => onClickLevel(2)} variant="contained" endIcon={selectedRows.length > 0 && rightLevel === 2 ? <span className="mr-8 px-[6px] py-[5px] bg-[#B5CEF0] rounded "><FiterIconAccount /></span> : undefined} ><GroupAccount stroke={`${rightLevel === 2 ? '#fff' : ''}`} />گروه</BasicButton>
            <BasicButton about="reviewAccount" className={` [&>.MuiButton-endIcon]:w-2/5 [&>.MuiButton-endIcon]:justify-end text-black w-1/5 ${rightLevel === 3 ? 'text-white' : topLevel === 3 ? "bg-[#E7EFFA]" : 'bg-[#FAFCFF]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => onClickLevel(3)} variant="contained" endIcon={selectedRows.length > 0 && rightLevel === 3 ? <span className="mr-8 px-[6px] py-[5px] bg-[#B5CEF0] rounded "><FiterIconAccount /></span> : undefined} ><Kol fill={rightLevel === 3 ? "#fff" : ""} />کل</BasicButton>
            <BasicButton about="reviewAccount" className={` [&>.MuiButton-endIcon]:w-2/5 [&>.MuiButton-endIcon]:justify-end text-black w-1/5 ${rightLevel === 4 ? 'text-white' : topLevel === 4 ? "bg-[#E7EFFA]" : 'bg-[#FAFCFF]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => onClickLevel(4)} variant="contained" endIcon={selectedRows.length > 0 && rightLevel === 4 ? <span className="mr-8 px-[6px] py-[5px] bg-[#B5CEF0] rounded "><FiterIconAccount /></span> : undefined} ><Moien stroke={`${rightLevel === 4 ? '#fff' : ''}`} />معین</BasicButton>
            <BasicButton about="reviewAccount" className={` [&>.MuiButton-endIcon]:w-2/5 [&>.MuiButton-endIcon]:justify-end text-black w-1/5 ${rightLevel === 5 ? 'text-white' : topLevel === 5 ? "bg-[#E7EFFA]" : 'bg-[#FAFCFF]'} border !border-blue-1 shadow-none rounded-lg`} onClick={() => onClickLevel(5)} variant="contained" endIcon={selectedRows.length > 0 && rightLevel === 5 ? <span className="mr-8 px-[6px] py-[5px] bg-[#B5CEF0] rounded "><FiterIconAccount /></span> : undefined} ><Tafsil stroke={`${rightLevel === 5 ? '#fff' : ''}`} />تفصیل</BasicButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                style={{ borderRadius: "4px" }}
                disableScrollLock
                MenuListProps={{ style: { padding: 0 } }}
                onClose={() => setAnchorEl(null)}
                transformOrigin={{ horizontal: "left", vertical: "top" }}
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            >
                {historyList.map((item, i) => {
                    return (
                        <MenuItem
                            key={i}
                            style={{ direction: "rtl" }}
                            className="gap-2"
                            onClick={() => {
                                
                            }}
                            >
                            <div  className="flex items-center justify-center">{item.title}</div>
                        </MenuItem>
                    );
                })}
            </Menu>
        </div>);
}

export default FilterAccountReview;